module.exports = __webpack_public_path__ + "media/backgrounds/nunzio-guerrera-8XKIbXCuqq8-unsplash-a193ad12.jpg";